// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopSupplierModel from '../../model/shop-supplier-model';
import ShopSupplierDTO from '../dto/shop-supplier-dto';
import dtoSchema from '../schemas/shop-supplier-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopSupplierModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopSupplierDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.name = data.name;
      this.validFrom = data.validFrom;
      this.validTo = data.validTo ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @minimum 1
  */
  name?: string;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validTo?: string;

  static toModel(dto: DeepPartial<ShopSupplierDTO>): ShopSupplierModel;
  static toModel(dto: DeepPartial<ShopSupplierDTO> | undefined | null): ShopSupplierModel | undefined;
  static toModel(dto: DeepPartial<ShopSupplierDTO> | undefined | null): ShopSupplierModel | undefined {
    return dto ? new ShopSupplierModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopSupplierModel> | ShopSupplierModel): ShopSupplierDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      name: unwrapped.name,
      validFrom: unwrapped.validFrom,
      validTo: unwrapped.validTo,
    } as ShopSupplierDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopSupplierModel, can not map to ShopSupplierDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
